import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import MotionReveal from "./MotionReveal";

export default function HomeFinalCta({ content }) {
  const primaryActions = content.actions.filter((action) => action.variant !== "tertiary").slice(0, 2);
  const secondaryAction = content.actions.find((action) => action.variant === "tertiary") || content.actions[2];
  const getActionMeta = (label) =>
    label.includes("Arbeitgeber")
      ? {
          eyebrow: "Arbeitgeber",
          hint: "Operativer Einstieg",
          detail: "Belastbare Kandidatenkontexte, Pflichten und Welcome-Logik sichtbar machen.",
        }
      : {
          eyebrow: "Fachkräfte",
          hint: "Orientierter Startpfad",
          detail: "Direkt in einen fairen, vorbereiteten und nachvollziehbaren Startpfad einsteigen.",
        };

  return (
    <section className="public-home-premium__section public-home-premium__section--closure" id="next-step">
      <div className="mx-auto w-full max-w-page px-4 sm:px-6 lg:px-8">
        <MotionReveal className="public-home-premium__cta-stage">
          <div className="public-home-premium__cta-stage-grid">
            <div className="public-home-premium__cta-copy">
              <span className="public-home-premium__eyebrow public-home-premium__eyebrow--hero">
                {content.eyebrow}
              </span>
              <h2>{content.title}</h2>
              <p>{content.text}</p>
            </div>

            <div className="public-home-premium__cta-action-grid">
              {primaryActions.map((action) => {
                const meta = getActionMeta(action.label);
                const toneClass = meta.eyebrow === "Arbeitgeber" ? "employer" : "talent";

                return (
                  <Link
                    key={action.label}
                    to={action.href}
                    className={`public-home-premium__cta-action-card public-home-premium__cta-action-card--${toneClass}`.trim()}
                  >
                    <span className="public-home-premium__mini-label">{meta.eyebrow}</span>
                    <strong>{action.label}</strong>
                    <span className="public-home-premium__cta-action-kicker">{meta.hint}</span>
                    <p className="public-home-premium__cta-action-detail">{meta.detail}</p>
                    <span className="public-home-premium__cta-action-arrow">
                      <ArrowRight size={18} strokeWidth={1.9} />
                    </span>
                  </Link>
                );
              })}
            </div>
          </div>

          {secondaryAction ? (
            <Link to={secondaryAction.href} className="public-home-premium__cta-link-rail">
              <span className="public-home-premium__cta-link-copy">
                <span className="public-home-premium__mini-label">Vertiefung</span>
                <strong>{secondaryAction.label}</strong>
                <span className="public-home-premium__cta-link-support">
                  Systemprinzip, Haltung und Verfahrenslogik vertiefen.
                </span>
              </span>
              <span className="public-home-premium__cta-link-arrow">
                <ArrowRight size={18} strokeWidth={1.9} />
              </span>
            </Link>
          ) : null}
        </MotionReveal>
      </div>
    </section>
  );
}
